import React, {forwardRef, ReactNode} from "react";
import {observer} from "mobx-react-lite";
import classNames from "classnames";


import {CalendarTodayIcon} from "../../icons/CalendarTodayIcon";
import {Tooltip} from "../../Tooltip";


import "./CalendarSelect.css";


interface CalendarSelectInputProps {
    className?: string;
    withBackground?: boolean;
    onClick: (event: React.MouseEvent) => void;
    label: string | ReactNode;
    isPlaceholder?: boolean;
    isOpen?: boolean;
    tooltipTitle?: string;
    maxWidth?: number;
}

export interface CalendarDay {
    month: number;
    day: number;
}

export const CalendarSelectInput = observer(forwardRef<HTMLDivElement, CalendarSelectInputProps>(
    (
        {
            onClick,
            label,
            className,
            withBackground,
            isPlaceholder = false,
            isOpen = false,
            tooltipTitle,
        },
        ref
    ) => {
        return (
            <div
                ref={ref}
                className={classNames({
                    "CalendarSelectInput body-large": true,
                    "CalendarSelectInput--placeholder": isPlaceholder,
                    "CalendarSelectInput--withBackground": withBackground,
                    "CalendarSelectInput--active": isOpen,
                    [className!]: className,
                })}
                onClick={onClick}
            >
                <span className="CalendarSelectInput__label-text">
                    {label}
                </span>
                <Tooltip title={tooltipTitle}>
                    <CalendarTodayIcon className="CalendarSelectInput__icon" size={20}/>
                </Tooltip>
            </div>
        );
    }
));
